import { Link } from 'react-router-dom';
import { Card, CardTitle, CardDescription, Button } from '@/components/ui';

export function NotFound() {
  return (
    <div className="mx-auto max-w-md py-16">
      <Card className="text-center">
        <div className="text-7xl font-extrabold text-gold-gradient">404</div>
        <CardTitle className="mt-4">페이지를 찾을 수 없습니다</CardTitle>
        <CardDescription className="mt-2">
          주소를 다시 확인하거나 대시보드로 돌아가세요
        </CardDescription>
        <Link to="/" className="inline-block mt-6">
          <Button variant="gold">홈으로</Button>
        </Link>
      </Card>
    </div>
  );
}
